import type { CirclesChart } from '../circlesChart.js';
import type { CirclesVariant } from '../gameTypes.js';
import { PALETTE_AURORA } from '../builtinPulseMaps/palettes.js';
import { assembleImportedCirclesChart } from './importedOsuChart.js';
import audioOnsets from './audio/hope.onsets.json' with { type: 'json' };
import normalImported from './imported/hope-normal.circles.json' with { type: 'json' };
import hardImported from './imported/hope-hard.circles.json' with { type: 'json' };
import extremeImported from './imported/hope-extreme.circles.json' with { type: 'json' };

export const HOPE_CIRCLES_VARIANTS: Record<CirclesVariant, CirclesChart> = assembleImportedCirclesChart({
  baseSlug: 'hope',
  baseTitle: "Dreams pt. II",
  description: "Lost Sky's melodic-trap with Sara Skinner's vocal hook. Soft drops and a clear hook — a calm entry-tier track.",
  difficulty: 1,
  palette: PALETTE_AURORA,
  audioSrc: '/audio/circles/hope.mp3',
  attribution: "\"Dreams pt. II (feat. Sara Skinner)\" by Lost Sky [NCS Release] - https://ncs.io/Dreams2",
  mapper: "Jonny_NOS",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 145, offsetMs: 0, totalBeats: 148 },
    hard: { bpm: 145, offsetMs: 0, totalBeats: 148 },
    extreme: { bpm: 145, offsetMs: 0, totalBeats: 148 },
  },
});
